<script setup lang="ts">
import enLocale from 'element-plus/lib/locale/lang/en'
import zhLocale from 'element-plus/lib/locale/lang/zh-cn'
const { locale } = useI18n()
const route = useRoute()
let lang = ref(locale.value === '中文' ? zhLocale : enLocale)
useHead({
  title: 'OC',
  meta: [{ name: 'description', content: 'oc' }]
})

// 页面是否缓存
const isKeepAlive = computed(() => {
  // 不做缓存配置的页面
  let notKeepAliveList = ['/autofulfillsettings']
  return !notKeepAliveList.includes(route.fullPath)
})
</script>

<template>
  <el-config-provider :locale="lang">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component v-if="isKeepAlive" :is="Component" :key='route.fullPath'/>
      </keep-alive>
      <component v-if="!isKeepAlive" :is="Component" :key='route.fullPath'/>
    </router-view>
  </el-config-provider>
</template>
